import { MAIN_BASE_URL } from '../apis/api';

export default function resolveMediaUrl(url) {
    if (!url) return '';
    const u = String(url);

    // Prevent Mixed Content on HTTPS pages by upgrading absolute http URLs.
    if (window?.location?.protocol === 'https:' && /^http:\/\//i.test(u)) {
        return u.replace(/^http:\/\//i, 'https://');
    }

    if (/^https?:\/\//i.test(u) || u.startsWith('data:') || u.startsWith('blob:')) return u;
    if (u.startsWith('//')) return `${window.location.protocol}${u}`;

    const needsSlash = !u.startsWith('/');
    return `${MAIN_BASE_URL}${needsSlash ? '/' : ''}${u}`;
}
